import axios from '../axios';

class Choice{
    constructor() {
        this.modifier_list = '/template/modifier/list';
        this.choice_url = '/template/choice';
    }
    getModifierList(params) {
        return axios(this.modifier_list, { method: 'get', params });
    }
    getChoice(id) {
        return axios(`${this.choice_url}/${id}`, { method: 'get'});
    }
    postChoice(params) {
        return axios(`${this.choice_url}`, { method: 'post', params});
    }
    putChoice(id, params) {
        return axios(`${this.choice_url}/${id}`, { method: 'put', params});
    }
    deleteChoice(id) {
        return axios(`${this.choice_url}/${id}`, { method: 'delete'});
    }
    choiceList(params){
        return axios(`${this.choice_url}/list`, { method: 'get', params});
    }
}

export default new Choice();




// WEBPACK FOOTER //
// ./src/api/modules/choice.js